// Subweb VLTT cuộn dọc thường — KHÔNG dùng fullpage swiper của scaffold ma-dao (trang này không có .main-swiper)

// Reload khi xoay màn hình (giữ từ scaffold — khớp quy ước PC/MB reload 1 lần)
window.addEventListener("orientationchange", function () {
    window.location.reload();
});

// ===== Báo libraryMainsite đo lại khi DOM đổi chiều cao =====
// Lib chỉ tính scale #MS__wrapper + set height cho <body> ở sự kiện `resize`. Nội dung trang này đổi SAU
// khi lib đã đo xong (backend render lại lưới thí sinh / BXH / ảnh dự thi khi lọc-sắp xếp-tìm-đổi trang,
// ảnh load muộn, popup, hoặc chính mình bớt DOM) => không bắn resize thì <body> giữ height cũ: THÊM thì
// trang cụt (cuộn không tới đáy), BỚT thì thừa một khoảng trắng dưới footer.
//
// Bám CHIỀU CAO THẬT của #MS__wrapper bằng ResizeObserver, KHÔNG bám danh sách hook pm__: đổi ở bất kỳ
// đâu trong trang (kể cả xoá nguyên section, đổi text làm xuống dòng, ảnh load xong) đều đổi chiều cao
// wrapper nên đều bắt được — bản trước chỉ observe mấy hook pm__ nên xoá DOM chỗ khác là lọt.
// Không lo lặp vô hạn: lib phản ứng bằng cách set height cho <body> + transform:scale cho wrapper, cả hai
// đều KHÔNG đổi border-box của wrapper (ResizeObserver bỏ qua transform); thêm chốt so height mới ≠ cũ.
// Idiom chung của repo (nghichthuyhan/2026-damyeudamke): window.dispatchEvent(new Event("resize")).
(function () {
	function watch() {
		var wrapper = document.getElementById("MS__wrapper");
		if (!wrapper || typeof ResizeObserver === "undefined") return;

		var lastH = Math.round(wrapper.getBoundingClientRect().height);
		var pending = false;

		new ResizeObserver(function () {
			if (pending) return;
			pending = true;
			// Bắn ở frame sau: gộp cả loạt thay đổi của một lần render về ĐÚNG 1 lần resize và để layout
			// ổn định rồi mới đo.
			requestAnimationFrame(function () {
				pending = false;
				var h = Math.round(wrapper.getBoundingClientRect().height);
				if (h === lastH) return;
				lastH = h;
				window.dispatchEvent(new Event("resize"));
			});
		}).observe(wrapper);
	}

	if (document.readyState === "complete") watch();
	else window.addEventListener("load", watch);
})();

// Backend ẩn/hiện 3 trang phụ tuỳ trạng thái nên section nào đứng ngay dưới #hero là chuyện lúc chạy,
// CSS không biết -> chấm class để chỉ section đó mang dải nối màu với đáy header. Chấm LẠI ở mỗi
// "resize" (ResizeObserver bên trên bắn ra) vì backend còn ẩn/đổi DOM sau khi trang đã tải.
(function () {
	function mark() {
		var pages = document.querySelectorAll("#danhsach, #thongtin, #xephang");
		var taken = false;
		for (var i = 0; i < pages.length; i++) {
			// offsetParent bắt display:none, offsetHeight bắt kiểu ẩn giữ chỗ (height 0).
			var first = !taken && pages[i].offsetParent !== null && pages[i].offsetHeight > 0;
			pages[i].classList.toggle("under-hero", first);
			if (first) taken = true;
		}
	}

	mark();
	window.addEventListener("resize", mark);
})();
